import ElementUI from 'element-ui'; /*node_modules引入了element-ui 这里就可以直接引用了*/
import 'element-ui/lib/theme-chalk/index.css'; /*node_modules引入了element-ui 这里就可以直接引用了*/
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '@/App.vue';
import router from '@/router';
import globelVar from '@/globelVar.js'
import axios from 'axios' //引入axios
import apis from "@/apis/index.js";
import ybapis from "@/apis/ybApi.js";
import store from '@/store';
import less from 'less' 
// import VueTouchKeyboard from "vue-touch-keyboard";//引入软键盘
// import  "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // 引入软键盘样式




    
Vue.config.productionTip = false

Vue.prototype.globelVar=globelVar;
Vue.use(ElementUI);/*ElementUI 是一个插件，所以需要使用use*/
Vue.use(VueRouter);/*ElementUI 是一个插件，所以需要使用VueRouter*/
Vue.use (less)
// Vue.use(VueTouchKeyboard);
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.timeout = 120000
//http request 拦截器
// Add a request interceptor
axios.interceptors.request.use(async function (config) {
  // Do something before request is sent
  
  //包头
  // console.log("token测试",config.url)
  if (config.data.qqflag == '1') {
    console.log("入参1",config.data.infcode);
    console.log("入参1",config.data.input);
  }else if (config.data.qqflag == '0') {
    // alert('请求拦截'+ JSON.stringify(config.data.data));
    config.data = config.data.data;

    //判断token是否过期
    // console.log("token测试",config.url)
    if(config.url != "http://10.200.5.56:8081/authorization"){ 
    // if(config.url != "/interface_token/authorization"){
      // console.log("token值1111") ;
      let authorization= await apis.refreshToken();
      // console.log("token值",authorization) ;
      config.headers['Authorization'] = "Bearer "+authorization;
    }

  } else{
    const nowdate = globelVar.tools.getNowDate();
    var res = await apis.execute('devinfo','');
    console.log(res);
    let devno = res.output.devno;
    // let devno = 'zzj_0001';
    let mes = {
      "infno": "1001",
      "msgid":  'gxfybjybankzz'+ nowdate.replaceAll("-","").replaceAll(" ","").replaceAll(":",""),  
      "recer_sys_code": "360399",
      "dev_no": devno,//"zzj_0001"
      "openid": "",
      "dev_safe_info": "",
      "cainfo": "",
      "signtype": "sm3",
      "infver": "v1.0",
      "inf_time": nowdate,  
      "input": null 
    }
    mes.infno=config.data.infcode;
    mes.input=config.data.input;
    config.data=mes;
  }
    // console.log("入参",config);

  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  // console.log('返回拦截',response.data);

  if(response.data.infcode===-1 || response.data.infcode==="-1"){
    ElementUI.Message({
      message: "提示："+JSON.stringify(response.data.err_msg),
      type: 'error',
      duration:10000,
      offset:1000
    }); 
    // return false;
  }
  
  // console.log("出参",JSON.stringify(response))
  return response;

}, function (error) {
  // Do something with response error
    // console.log('err' + error) // for debug
    ElementUI.Message({
      message: error.message,
      type: 'error',
      offset:300
    })
  return Promise.reject(error);
});




Vue.prototype.axios = axios;
Vue.prototype.apis = apis;
Vue.prototype.$ybApis = ybapis;
new Vue({
  render: h => h(App),
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this; //安装全局事件总线
  },
}).$mount('#app')

